module.exports = __webpack_public_path__ + "img/portugal-infectious-diseases-male.938c6519.png";